export const appColors = {
  primary100: "#B81A8E",
  textgray: "#B0B0B0",
};
